<template>
    <div class="base-form-div" v-loading="loading" element-loading-text="正在上传..." element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 0.8)">
        <el-form size="mini" :model="ruleForm" :rules="rules" ref="ruleForm" label-width="160px" class="demo-ruleForm">
            <el-form-item label="发送方卡号">
                <el-input :disabled="true" v-model="ruleForm.cardNumber"></el-input>
            </el-form-item>
            <el-form-item label="装备字典文件" prop="files">
                <el-upload :on-remove="handleRemoveImportExecl" :http-request="uploadFilesImportExecl"
                    :file-list="ruleForm.files" :auto-upload="true" drag :accept="'.jpg,.JPG'" :action="''"
                    :multiple="false">
                    <i class="el-icon-upload"></i>
                    <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
                    <div class="el-upload__tip" slot="tip">只能上传jpg格式图片</div>
                </el-upload>
            </el-form-item>
            <div class="form-bottom">
                <el-button class="base-button" size="mini" type="primary" @click="submitForm('ruleForm')">确定</el-button>
            </div>
        </el-form>
    </div>
</template>
<script>
import { postCommonAjax } from "@/api/common"
export default {
    props: ["subData"],
    data() {
        return {
            loading: false,
            accept: ["jpg", "JPG"],
            ruleForm: {
                cardNumber:"",
                files: [],
            },
            rules: {
                files: [
                    {
                        required: true, validator: (rule, value, callback) => {
                            if (!value || value.length < 1) {
                                callback(new Error('请选择需要上传的文件'));
                            } else {
                                callback();
                            }
                        },
                        trigger: "change"
                    },
                ],
            },
        };
    },
    methods: {
        chechAccept(fileName) {
            const i = fileName.lastIndexOf(".");
            let suf = "";
            if (i < 0) {
                return false;
            }
            suf = fileName.substr(i + 1);
            return this.accept.includes(suf);
        },
        handleRemoveImportExecl() {
            this.ruleForm.files = [];
        },
        uploadFilesImportExecl(file) {
            const fileName = file.file.name;
            var check = this.chechAccept(fileName);
            if (check) {
                this.ruleForm.files = [file.file];
                return false;
            }
            this.$message({
                showClose: true,
                message: "您导入的文件格式暂不支持！",
                type: "error",
            });
            return false;
        },
        submitForm(formName) {
            console.log(this.ruleForm);
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.loading = true;
                    var formdata = new FormData();
                    formdata.append("cardNumber", this.ruleForm.cardNumber);
                    formdata.append("file", this.ruleForm.files[0]);
                    postCommonAjax("/picture/uploadJpg", formdata).then(() => {
                        this.$message({
                            message: "上传成功",
                            type: "success",
                        });
                        this.loading = false;
                        this.$bus.$emit("sendPic-list");
                        this.$parent.close();
                    });
                } else {
                    return false;
                }
            });
        },
        resetForm(formName) {
            this.$refs[formName].resetFields();
        },
    },
    created() {
        this.ruleForm.cardNumber=this.subData;
    },
    mounted() { },
};
</script>
<style>
.form-bottom {
    margin-bottom: 0 !important;
    text-align: center;
}

.el-input-number {
    width: 100%;
}
</style>